// extracted by mini-css-extract-plugin
module.exports = {"author":"author-module--author--3DXLv","about":"author-module--about--JuWCN","image":"author-module--image--2sc-h"};